"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function FAQUniversityEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultItems = [
    { q: "What are the admission requirements?", a: "Admission requirements vary by program but generally include high school transcripts..." },
    { q: "Do you offer scholarship opportunities?", a: "Yes, we offer both merit-based and need-based scholarships..." },
    { q: "Can I transfer credits from another institution?", a: "Transfer credits are evaluated on a case-by-case basis by the registrar's office." }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Frequently Asked Questions"
            />
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Find answers to common questions about admissions..."
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">FAQ Items</h4>
            <ListItemEditor
              label="FAQs"
              items={content.items || defaultItems}
              itemSchema={[
                { key: "q", label: "Question", type: "text" },
                { key: "a", label: "Answer", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, items })}
              addItemText="Add FAQ Item"
            />
          </div>
        </div>
      }
    />
  );
}
